import { ISalesState } from "@/core/interfaces/salesState.interface";

const salesState: ISalesState = {
  isLoading: false,
  sectors: null,
  salesSnapshot: null,
  salesProductivity: null,
  isSalesMyTeamLoading: false,
  salesMyTeam: [],
  isSalesSectorsFetching: false,
};

export default salesState;
